import Image from "next/image"
import styles from "./forestry.module.css";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import NewiconA from "../../assets/images/header/pdf-download1.png";
// import Webbanner from "../../assets/images/Delhi/Forestry-Optional-Delhi-Web-Banner.jpg";
// import Mobbanner from "../../assets/images/Delhi/Forestry-Optional-Delhi-Mobile-Banner.jpg";
import Link from "next/link";
import Head from "next/head";

const Forestry_Geology_Optional_Programme = () => {

    const feestructure3 =[
        {optional: "Forestry",mode: "B1 - (Offline & Online)", start: "12-09-2026",fee:(<><div>₹6,000</div></>),
          cont3:(<Link href="https://www.shankariasacademy.com/pdf/UPSC-2026/Moksha-Optional/Forestry/FORESTRY-TEST-SCHEDULE-2026.pdf"  target="_blank" className={`${styles.paybill}`}> 
                <Image src={NewiconA} alt="download icon"  className={`${styles.downloadicon}`}/>Click Here</Link>),
            pay: (<a href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=UPSC" target="_blank" rel="noopener noreferrer">
                    <button className={`${styles.normalbutton1} btn btn-danger`}>
                      Pay Now
                    </button>
                </a>)
            },

        //     {optional: "Forestry",mode: "B2 - (Offline & Online)", start: "15-09-2025",fee:(<><div>₹9,000</div></>),
        //   cont3:(<Link href="https://www.shankariasacademy.com/pdf/Moksha-Mains-2026/Forestry/FORESTRY-TEST-B2-SCHEDULE-2025.pdf" target="blank" className={`${styles.paybill}`}> 
        //         <Image src={NewiconA} alt="download icon"  className={`${styles.downloadicon}`}/>Click Here</Link>),
        //     pay: (<a href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=UPSC" target="_blank" rel="noopener noreferrer">
        //             <button className={`${styles.normalbutton1} btn btn-danger`}>
        //               Pay Now
        //             </button>
        //         </a>)
        //     }
    ];


    return (
        <>

            <Head>
                <meta charset="UTF-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <meta name="robots" content="noodp,noydir" />
                <meta name="robots" content="index,follow" />
                <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
                <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
                <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
                <title>Forestry Mains Test Series 2026</title>
                <meta name="title" content="Forestry Mains Test Series 2026" />
                <meta name="description" content=" Forestry Mains Test Series 2026" />
                <link rel="canonical" href=" https://www.shankariasacademy.com/upsc-forestry-mains-test-series/" />
                <meta property="og:locale" content="en_US" />
                <meta property="og:type" content="website" />
                <meta property="og:title" content="Forestry Mains Test Series 2026" />
                <meta property="og:description" content="" />
                <meta property="og:url" content=" https://www.shankariasacademy.com/upsc-forestry-mains-test-series/" />
                <meta property="og:site_name" content="Shankar IAS Academy" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@shankarias" />
              </Head>

        <Navbar title="upsc" />
       
            <div className="container">
                <div className="row">
                <div className="col pt-3 pt-md-4">
                    <h1 className={`${styles.pagemaintitle}`}>Forestry Mains Test Series 2026</h1>
                </div>
                </div>
                
           {/* <div className="row">
                    <div className="col pt-2 mb-3 d-none d-md-block">
                        <Image src={Webbanner} alt="Forestry Optional Programme banner" title="Admission open for Forestry Optional Programme" className="img-fluid w-100" />
                    </div>
            </div>

            <div className="row  d-block d-md-none">
                <div className="col pt-2 mb-3">
                    <Image src={Mobbanner} alt="Forestry Optional Programme banner" title="Admission open for Forestry Optional Programme" className="img-fluid w-100" />
                </div>
            </div> */}

                
                {/* <div className="row pt-2">
                <div className="col-md-9 col-12">
                    <h2 className={`${styles.sectiontitle} mb-0`}>Admission open for Forestry  Optional Programme</h2>
                </div>
                </div> */}
                </div>

         {/* <div className="container">
            <div className="row pt-md-4 pt-3">
                <div className="col">
                <p className={`${styles.sectionsubtitle} mb-2`}>Forestry Optional</p>
                </div>
            </div>
        </div>

        {/* table 1*/}


    <section  id="courseandfees">
        <div className="container pt-xl-4" >
            <div className="row">
                <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#ffbdac" }}>Optional</div>
                <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#fee5d3" }}>Batch</div>
                <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#ffbdac" }}>Starts on</div>
                <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#fee5d3" }}>Fee</div>
                <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#ffbdac" }}>Schedule</div> 
                <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#fee5d3" }}>Admission</div>
                <hr/>
            </div>
                        
            {feestructure3.map((item,index)=>(
                <div className={`${styles.facultyborder3} row`}>
                    <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Optional</div>
                        <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-3`}>{item.optional}</div>
                    <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Batch</div>
                        <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-3  pb-md-3`}>{item.mode}</div>
                    <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Starts on</div>
                        <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-3`}>{item.start}</div>
                        <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Fee</div>
                        <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-3`}>{item.fee}</div>
                    <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Schedule</div>
                        <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-2`}>{item.cont3}</div> 
                    <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Admission</div>
                        <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-2 text-center pt-2 pt-md-2`}>
                {item.pay}
                </div>
                <hr/>
                </div>
            ))} 
        
        </div>
    </section>


    <Footer />                      
        </>
    )
  } 
export default Forestry_Geology_Optional_Programme